<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-5">Data Akun WhatsApp</span>
		</div>
		<div class="card-body">
			<div class="row g-2 justify-content-end mb-3">
				<div class="col-auto" v-if="isPengembang">
					<el-button type="info" icon="Plus" plain round @click="dialogCreateVisible = true">Tambah akun WhatsApp</el-button>
				</div>
				<div class="col-auto">
					<el-button type="primary" icon="Refresh" plain round bg @click="initAllSessions">Tautkan semua sesi</el-button>
				</div>
				<div class="col-auto" v-if="isPengembang">
					<el-button type="success" plain round bg @click="dialogMessageVisible = true">
						<el-icon class="el-icon--left"><i class="bi bi-send-plus-fill"></i></el-icon>Tes kirim pesan
					</el-button>
				</div>
			</div>

			<el-form :model="formEdit" @submit.prevent="updateAccount" :rules="rulesEdit" ref="formEdit" inline-message>
				<el-table
					:data="sessions"
					table-layout="auto"
					border
					stripe
					v-loading="loading"
					:header-cell-style="{ background: 'var(--el-fill-color-light)' }"
					class="shadow-sm"
					:cell-class-name="cellClass">
					<template #empty>
						<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
					</template>
					<el-table-column type="index" label="No." align="center" />
					<el-table-column prop="session_wa_id" label="ID Sesi" align="center" sortable>
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<span :key="row.session_wa_id">
									{{ row.session_wa_id }}
								</span>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Nomor" prop="nomor" align="center" sortable>
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-form-item prop="nomor" v-if="rowEditing === row" class="mb-0">
									<el-input v-model="formEdit.nomor" :placeholder="row.nomor" clearable style="min-width: 150px" />
								</el-form-item>
								<div class="hstack gap-1 justify-content-center" v-else :key="row.nomor">
									{{ row.nomor }}
									<el-tooltip v-if="isPengembang">
										<template #content>
											Dibuat: <em>{{ row.created_at }}</em>
											<br />
											Diperbarui: <em>{{ row.updated_at || "-" }}</em>
										</template>
										<el-icon><i class="bi bi-info-circle"></i></el-icon>
									</el-tooltip>
								</div>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Status" align="center">
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<span :key="row.status">
									{{ statuses[row.status] || row.status }}
								</span>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Tindakan Sesi" align="center">
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<div :key="row.status">
									<el-tooltip
										:content="actionStatus[row.session_wa_id]?.action ? actionStatus[row.session_wa_id].process : 'Tautkan sesi WhatsApp'"
										v-if="row.status === 'revoked'">
										<el-button
											type="info"
											size="small"
											plain
											round
											@click="initSession(row)"
											icon="Connection"
											:loading="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action === 'init'"
											:disabled="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action !== 'init'" />
									</el-tooltip>
									<el-tooltip
										:content="actionStatus[row.session_wa_id]?.action ? actionStatus[row.session_wa_id].process : 'Tautkan ulang'"
										v-else-if="row.status === 'disconnected' || row.status === 'destroyed'">
										<el-button
											type="primary"
											size="small"
											plain
											round
											@click="reinitSession(row)"
											icon="Refresh"
											:loading="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action === 'reinit'"
											:disabled="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action !== 'reinit'" />
									</el-tooltip>
									<el-space v-else>
										<el-tooltip :content="actionStatus[row.session_wa_id]?.action ? actionStatus[row.session_wa_id].process : 'Tampilkan kode QR'" v-if="row.status === 'qr'">
											<el-button type="info" size="small" plain round @click="selectedData = row" :disabled="actionStatus[row.session_wa_id]?.loading">
												<el-icon><i class="bi bi-qr-code-scan"></i></el-icon>
											</el-button>
										</el-tooltip>
										<el-tooltip :content="actionStatus[row.session_wa_id]?.action ? actionStatus[row.session_wa_id].process : 'Tautkan ulang'" v-else>
											<span>
												<el-popconfirm
													:title="`Tautakan ulang sesi [${row.session_wa_id}]?`"
													confirm-button-type="primary"
													confirm-button-text="Ya, Tautkan Ulang"
													cancel-button-text="Batal"
													hide-icon
													width="200"
													@confirm="reinitSession(row)">
													<template #reference>
														<el-button
															type="primary"
															size="small"
															plain
															round
															icon="Refresh"
															:loading="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action === 'reinit'"
															:disabled="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action !== 'reinit'" />
													</template>
												</el-popconfirm>
											</span>
										</el-tooltip>
										<el-tooltip :content="actionStatus[row.session_wa_id]?.loading ? actionStatus[row.session_wa_id].process : 'Nonaktifkan sesi'">
											<span>
												<el-popconfirm
													:title="`Anda yakin ingin menonaktifkan sesi [${row.session_wa_id}]?`"
													confirm-button-type="warning"
													confirm-button-text="Ya, Nonaktifkan"
													cancel-button-text="Batal"
													hide-icon
													width="200"
													@confirm="destroySession(row)">
													<template #reference>
														<el-button
															type="warning"
															size="small"
															plain
															round
															icon="CloseBold"
															:loading="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action === 'destroy'"
															:disabled="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action !== 'destroy'" />
													</template>
												</el-popconfirm>
											</span>
										</el-tooltip>
										<el-tooltip :content="actionStatus[row.session_wa_id]?.loading ? actionStatus[row.session_wa_id].process : 'Hapus sesi'">
											<span>
												<el-popconfirm
													:title="`Anda yakin ingin menghapus sesi [${row.session_wa_id}]?`"
													confirm-button-type="danger"
													confirm-button-text="Ya, Hapus"
													cancel-button-text="Batal"
													hide-icon
													width="200"
													@confirm="logoutSession(row)">
													<template #reference>
														<el-button
															type="danger"
															size="small"
															plain
															round
															icon="Delete"
															:loading="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action === 'logout'"
															:disabled="actionStatus[row.session_wa_id]?.loading && actionStatus[row.session_wa_id]?.action !== 'logout'" />
													</template>
												</el-popconfirm>
											</span>
										</el-tooltip>
									</el-space>
								</div>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Tindakan Akun" align="center" v-if="isPengembang">
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-space v-if="rowEditing === row">
									<el-button type="info" size="small" plain round @click="rowEditing = null">Batal</el-button>
									<el-button type="success" size="small" round native-type="submit" :loading="updating">Simpan</el-button>
								</el-space>
								<el-space v-else>
									<el-tooltip content="Edit nomor">
										<el-button type="primary" size="small" icon="Edit" plain round @click="rowEditing = row" />
									</el-tooltip>
									<el-tooltip content="Hapus akun">
										<span>
											<el-popconfirm
												:title="`Anda yakin ingin menghapus akun [${row.session_wa_id}]?`"
												confirm-button-type="danger"
												confirm-button-text="Ya, Hapus"
												cancel-button-text="Batal"
												hide-icon
												width="200"
												@confirm="deleteAccount(row)">
												<template #reference>
													<el-button type="danger" size="small" plain round icon="Delete" :loading="deleting === row" />
												</template>
											</el-popconfirm>
										</span>
									</el-tooltip>
								</el-space>
							</transition>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
		</div>

		<el-dialog v-model="qrDialogVisible" align-center @closed="selectedData = null" width="auto">
			<template #header>
				Pindai Kode QR [
				<code class="fw-bold">{{ selectedData?.session_wa_id }}</code>
				]
			</template>
			<div class="text-center">
				<img :src="selectedData.qr" alt="" v-if="selectedData?.qr" />
			</div>
		</el-dialog>

		<el-form
			:model="formCreate"
			:rules="rulesCreate"
			ref="formCreate"
			label-width="auto"
			label-position="top"
			require-asterisk-position="right"
			@submit.prevent="createAccount"
			:disabled="inserting">
			<el-dialog v-model="dialogCreateVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Tambah Akun WhatsApp" align-center :width="modalWidth">
				<el-row :gutter="10">
					<el-col :xs="24" :sm="12">
						<el-form-item label="ID Sesi" prop="session_wa_id">
							<el-input v-model="formCreate.session_wa_id" placeholder="Identitas unik akun WhatsApp" clearable />
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12">
						<el-form-item label="Nomor Akun" prop="nomor">
							<el-input v-model="formCreate.nomor" placeholder="Nomor akun WhatsApp" clearable />
						</el-form-item>
					</el-col>
				</el-row>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>

		<el-form :model="formMessage" :rules="rulesMessage" ref="formMessage" label-width="auto" @submit.prevent="sendTestMessage" :disabled="sending">
			<el-dialog
				v-model="dialogMessageVisible"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				title="Uji Coba Pengiriman Pesan WhatsApp"
				align-center
				:width="modalWidth">
				<el-form-item label="Nomor Tujuan" prop="kontak">
					<el-input v-model="formMessage.kontak" placeholder="Nomor WhatsApp tujuan" clearable />
				</el-form-item>
				<el-form-item label="Pesan" prop="message">
					<el-input v-model="formMessage.message" :autosize="{ minRows: 2 }" type="textarea" placeholder="Isi pesan" />
				</el-form-item>
				<template #footer>
					<el-button type="info" plain @click="dialogMessageVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="sending">Kirim</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
export default {
	name: "WaSessionsView",
	data() {
		return {
			sessions: [],
			statuses: {
				initializing: "Menyiapkan sesi...",
				connecting: "Menghubungkan...",
				qr: "Pindai kode QR!",
				ready: "Terhubung (Aktif)",
				disconnected: "Terputus (Offline)",
				destroyed: "Nonaktif (Stopped)",
				revoked: "Sesi dihapus (Logout)",
			},
			loading: true,
			modalWidth: "50%",
			dialogCreateVisible: false,
			dialogMessageVisible: false,
			formMessage: {
				kontak: null,
				message: null,
			},
			formCreate: {
				session_wa_id: null,
				nomor: null,
			},
			rowEditing: null,
			formEdit: {
				nomor: null,
			},
			rulesMessage: {
				kontak: [
					{ required: true, message: "Masukkan nomor WhatsApp tujuan", trigger: "change" },
					{
						pattern: /^[0-9]{10,13}$/,
						message: "Format nomor WhatsApp tujuan tidak valid (Gunakan format: 08xx / 628xx)",
						trigger: "blur",
					},
				],
				message: [{ required: true, message: "Pesan tidak boleh kosong", trigger: "change" }],
			},
			rulesCreate: {
				session_wa_id: [
					{ required: true, message: "ID sesi WhatsApp harus diisi", trigger: "change" },
					{
						validator: (rule, value, callback) => {
							const exists = this.sessions.some((s) => s.session_wa_id === value);
							if (!value) {
								callback(new Error("ID sesi WhatsApp harus diisi"));
							} else if (exists) {
								callback(new Error("ID sesi WhatsApp sudah digunakan!"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				nomor: [
					{ required: true, message: "Nomor akun WhatsApp harus diisi", trigger: "change" },
					{
						validator: (rule, value, callback) => {
							const exists = this.sessions.some((m) => m.nomor === value);
							if (!value) {
								callback(new Error("Nomor akun WhatsApp harus diisi"));
							} else if (exists) {
								callback(new Error("Nomor akun WhatsApp sudah terdaftar!"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
			},
			rulesEdit: {
				nomor: [
					{ required: true, message: "Masukkan Nomor akun WhatsApp yang baru", trigger: "change" },
					{
						validator: (rule, value, callback) => {
							const sama = this.rowEditing.nomor === value;
							const exists = this.sessions.some((m) => m.nomor === value);

							if (!value) {
								callback(new Error("Masukkan Nomor akun WhatsApp yang baru"));
							} else if (sama) {
								callback(new Error("Tidak ada perubahan dari nomor sebelumnya!"));
							} else if (exists) {
								callback(new Error("Nomor akun WhatsApp sudah terdaftar!"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
			},
			actionStatus: {},
			qrDialogVisible: false,
			selectedData: null,
			inserting: false,
			updating: false,
			deleting: null,
			sending: false,
		};
	},
	computed: {
		isPengembang() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev"].includes(r.role));
		},
	},
	watch: {
		selectedData(val) {
			if (val) {
				this.qrDialogVisible = true;
			}
		},
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
		},
		dialogMessageVisible() {
			this.$refs.formMessage.resetFields();
		},
		rowEditing() {
			this.$refs.formEdit.resetFields();
			this.formEdit = {
				nomor: null,
			};
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		this.$ws.main.on("wa:status", this.updatedSession);
		this.$ws.main.on("session_wa:inserted", this.insertedAccount);
		this.$ws.main.on("session_wa:updated", this.updatedAccount);
		this.$ws.main.on("session_wa:deleted", this.deletedAccount);
		this.getSessions();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		this.$ws.main.off("wa:status");
		this.$ws.main.off("session_wa:inserted");
		this.$ws.main.off("session_wa:updated");
		this.$ws.main.off("session_wa:deleted");
	},
	methods: {
		updatedSession(data) {
			for (const s of this.sessions) {
				if (s.session_wa_id === data.session_wa_id) {
					s.status = data.status;
					s.qr = data.qr;

					if (data.status === "qr") {
						this.actionStatus[data.session_wa_id] = {
							loading: false,
							action: null,
							process: null,
						};
					} else {
						if (data.session_wa_id === this.selectedData?.session_wa_id && this.qrDialogVisible) {
							this.$notify.success({
								title: "Berhasil",
								message: `Kode QR sesi [${data.session_wa_id}] berhasil dipindai`,
							});

							this.qrDialogVisible = false;
						}

						s.qr = null;
					}
					break;
				}
			}
		},
		insertedAccount(data) {
			this.loading = true;
			this.sessions.push({
				...data,
				created_at: new Date(data.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
			});

			this.actionStatus[data.session_wa_id] = {
				loading: true,
				action: "init",
				process: "Sedang menyiapkan sesi",
			};

			setTimeout(() => {
				this.loading = false;
			}, 500);
		},
		updatedAccount(data) {
			const index = this.sessions.findIndex((s) => s.session_wa_id === data.session_wa_id);

			if (index !== -1) {
				this.sessions[index] = {
					...data,
					created_at: new Date(data.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					updated_at: new Date(data.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
				};
				this.actionStatus[data.session_wa_id] = {
					loading: true,
					action: "init",
					process: "Sedang menyiapkan sesi",
				};
			}
		},
		deletedAccount(data) {
			const index = this.sessions.findIndex((s) => s.session_wa_id === data.session_wa_id);

			if (index !== -1) this.sessions.splice(index, 1);
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 500) this.modalWidth = "90%";
			else if (w < 768) this.modalWidth = "80%";
			else if (w < 992) this.modalWidth = "70%";
			else if (w < 1200) this.modalWidth = "55%";
			else if (w < 1500) this.modalWidth = "40%";
			else if (w < 1920) this.modalWidth = "35%";
			else this.modalWidth = "30%";
		},
		cellClass({ row }) {
			if (this.rowEditing === row) {
				return "align-top";
			}
			return "";
		},
		async getSessions() {
			try {
				const { data } = await this.$defaultApi.get("/wa/index");

				await new Promise((resolve) => setTimeout(resolve, 500));
				const result = data.data.session_wa;

				result.forEach((r) => {
					r.created_at = new Date(r.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
					r.updated_at = r.updated_at ? new Date(r.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }) : null;
				});

				this.sessions = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async initSession(sesi) {
			this.actionStatus[sesi.session_wa_id] = { loading: true, action: "init", process: "Sedang menyiapkan sesi" };
			try {
				const { data } = await this.$defaultApi.post("/wa/command", {
					command: "INIT",
					session_wa_id: sesi.session_wa_id,
				});

				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.data.message,
					});

					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
			}
		},
		async destroySession(sesi) {
			this.actionStatus[sesi.session_wa_id] = { loading: true, action: "destroy", process: "Sedang menonaktifkan sesi" };
			try {
				const { data } = await this.$defaultApi.post("/wa/command", {
					command: "DESTROY",
					session_wa_id: sesi.session_wa_id,
				});

				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.data.message,
					});

					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
			}
		},
		async logoutSession(sesi) {
			this.actionStatus[sesi.session_wa_id] = { loading: true, action: "logout", process: "Sedang menghapus sesi" };
			try {
				const { data } = await this.$defaultApi.post("/wa/command", {
					command: "LOGOUT",
					session_wa_id: sesi.session_wa_id,
				});

				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.data.message,
					});

					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
			}
		},
		async reinitSession(sesi) {
			this.actionStatus[sesi.session_wa_id] = { loading: true, action: "reinit", process: "Sedang menautkan ulang sesi" };
			try {
				const { data } = await this.$defaultApi.post("/wa/command", {
					command: "REINIT",
					session_wa_id: sesi.session_wa_id,
				});
				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.data.message,
					});

					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.actionStatus[sesi.session_wa_id] = { loading: false, action: null, process: null };
			}
		},
		async initAllSessions() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/wa/command", {
					command: "INIT_ALL",
				});

				setTimeout(() => {
					this.$notify.success({
						title: "Berhasil",
						message: data.data.message,
					});
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		},
		async createAccount() {
			this.inserting = true;

			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.post("/wa", this.formCreate);

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateAccount() {
			this.updating = true;

			try {
				if (!this.formEdit.nomor) {
					throw new Error("Belum ada perubahan");
				}

				const valid = await this.$refs.formEdit.validate((res) => {
					return res;
				});

				if (!valid) {
					throw new Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.patch(`/wa/${this.rowEditing.session_wa_id}`, {
					nomor: this.formEdit.nomor,
				});

				this.rowEditing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.updating = false;
				}, 500);
			}
		},
		async deleteAccount(row) {
			this.deleting = row;

			try {
				const { data } = await this.$defaultApi.delete(`/wa/${row.session_wa_id}`);

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = null;
				}, 500);
			}
		},
		async sendTestMessage() {
			this.sending = true;

			try {
				const valid = await this.$refs.formMessage.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.post("/wa/test-message", this.formMessage);

				this.dialogMessageVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.sending = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
